// extracted by mini-css-extract-plugin
export default {"desktop":"(max-width: 1512px)","tablet":"(max-width: 1024px)","carousel":"mediaCarousel_carousel__mv+7B"};